import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component:() => import('@/view/index.vue')
    },{
      path: '/282',
      name: 'Index',
      component: () => import('@/view/index.vue')
    },{
      path: '/171',
      name: '171',
      component: () => import('@/view/aboutUs.vue'),
      children:[
        {
          path: '181',
          name: '181',
          component: () => import('@/view/aboutUs.vue')
        },{
          path: '191',
          name: '191',
          component: () => import('@/view/aboutUs.vue')
        },{
          path: '201',
          name: '201',
          component: () => import('@/view/aboutUs.vue')
        }
      ]
    },{
      // 政策动态
      path: '/211',
      name: '211',
      component: () => import('@/view/policyDynamic.vue'),
      children:[
        {
          // 公司动态
          path: '261',
          name: '261',
          component: () => import('@/view/policyInfo.vue'),
          children:[
            {
              path:'textInfo',
              component: () => import('../view/policyInfo.vue')
            }
          ]
        },{
          // 政策新闻
          path: '271',
          name: '271',
          component: () => import('@/view/policyInfo.vue'),
          children:[
            {
              path:'textInfo',
              component: () => import('../view/policyInfo.vue')
            }
          ]
        },{
          // 党群工作
          path: '291',
          name: '291',
          component: () => import('@/view/policyInfo.vue'),
          children:[
            {
              path:'textInfo',
              component: () => import('../view/policyInfo.vue')
            }
          ]
        }
      ]
    },{
      path: '/221',
      name: 'Solution',
      component: () => import('@/view/solution.vue')
    },{
      path: '/231',
      name: 'ProjectCase',
      component: () => import('@/view/projectCase.vue')
    },{
      path: '/241',
      name: 'JoinUs',
      component: () => import('@/view/joinUs.vue')
    },{
      // 联系我们
      path: '/251',
      name: 'ContactUs',
      component: () => import('@/view/contactUs.vue')
    },{
      path: '/292',
      name: 'Tenderee',
      component: () => import('@/view/tenderee.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js